import PropTypes from "prop-types";
import { openBase64Image } from "../../lib/utils/helper";

export default function FileCard({ mediaItem, fileIndex, index }) {
  const fileUrl = typeof mediaItem === "string" ? mediaItem : (mediaItem.previewUrl || mediaItem.fileUrl);

  const fileName =
    typeof mediaItem === "object" && mediaItem.fileName
      ? mediaItem.fileName
      : decodeURIComponent(fileUrl.split("/").pop().split("?")[0]);


 
const fileExtension = fileName.includes(".")
  ? fileName.slice(fileName.lastIndexOf(".") + 1).toLowerCase()
  : null;
  
console.log("fileexention",fileExtension)
  return (
    <button
      key={`file-${index}-${fileIndex}`}
      onClick={() => {
        if (fileUrl.startsWith("data:")) {
          openBase64Image(fileUrl);
        } else {
          window.open(fileUrl, "_blank");
        }
      }}
      type="button"
      className="bg-[#f0f0f0] hover:bg-[#e0e0e0] rounded px-3 py-2 text-sm cursor-pointer transition-colors w-full text-left"
    >
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 flex-shrink-0">
          <img
            width={50}
            height={50}
            src={fileExtension? `/extentionIcons/${fileExtension}.svg` : `/extentionIcons/file.png`}
            alt="file icon"
          />
        </div>
        <span className="max-w-[12vw] truncate">{fileName}</span>

        <div className="flex-shrink-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
          <polyline points="15 3 21 3 21 9"></polyline>
          <line x1="10" y1="14" x2="21" y2="3"></line>
        </svg>
        </div>
      </div>
    </button>
  );
}

FileCard.propTypes = {
  mediaItem: PropTypes.object.isRequired, // or a more specific shape if you know it
  fileIndex: PropTypes.number,
  index: PropTypes.number,
};
